export default __webpack_public_path__ + "static/media/ic_vpn_key.15943090.svg";